import React, { useState } from 'react';
import { MedalTone } from '../../utils/alert-kind';
import { isAllowedAssetUrl } from '../../utils/donate-alert';

// Huy hiệu bạc (Nổi bật) và vàng (Đặc biệt) trên thẻ thông báo. Bản dựng sẵn bằng SVG trong code; khi designer có file thì
// truyền url (Dropbox của Cab), ảnh lỗi thì quay về bản dựng sẵn.

const TONES: Record<MedalTone, { light: string; mid: string; dark: string; ribbon: string; ribbonDark: string }> = {
  silver: { light: '#FFFFFF', mid: '#C9D1DC', dark: '#7C8796', ribbon: '#4F7BD9', ribbonDark: '#2F55A8' },
  gold: { light: '#FFF6C2', mid: '#F2C23A', dark: '#A8700A', ribbon: '#D93F3F', ribbonDark: '#A12626' },
};

export const MedalSvg: React.FC<{ tone: MedalTone; size: number }> = ({ tone, size }) => {
  const c = TONES[tone];
  const id = `cab-medal-${tone}`;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" data-medal={tone}>
      <defs>
        <linearGradient id={`${id}-face`} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor={c.light} />
          <stop offset="0.5" stopColor={c.mid} />
          <stop offset="1" stopColor={c.dark} />
        </linearGradient>
      </defs>
      <path d="M20 2 L30 26 L22 30 L12 6 Z" fill={c.ribbon} />
      <path d="M44 2 L34 26 L42 30 L52 6 Z" fill={c.ribbonDark} />
      <circle cx="32" cy="40" r="21" fill={c.dark} />
      <circle cx="32" cy="40" r="18" fill={`url(#${id}-face)`} />
      <path
        d="M32 28 L35.5 35.5 L43.5 36.3 L37.5 41.6 L39.3 49.5 L32 45.4 L24.7 49.5 L26.5 41.6 L20.5 36.3 L28.5 35.5 Z"
        fill={c.light}
        stroke={c.dark}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const AlertMedal: React.FC<{ tone: MedalTone; url?: string | null; size?: number; className?: string }> = ({
  tone,
  url,
  size = 40,
  className,
}) => {
  const [failed, setFailed] = useState(false);
  const useFile = !!url && isAllowedAssetUrl(url) && !failed;
  return (
    <span className={className} style={{ display: 'inline-flex', width: size, height: size, flexShrink: 0 }}>
      {useFile ? (
        <img
          src={url as string}
          alt=""
          width={size}
          height={size}
          style={{ objectFit: 'contain' }}
          onError={() => setFailed(true)}
        />
      ) : (
        <MedalSvg tone={tone} size={size} />
      )}
    </span>
  );
};

export default AlertMedal;
